/**
 * InlineTip
 * 
 * Minimal, refined contextual tip component with black/grey aesthetic
 */

import { cn } from "@/lib/utils";
import { HugeiconsIcon } from "@hugeicons/react"
import { BulbIcon } from "@hugeicons/core-free-icons"

interface InlineTipProps {
  children: React.ReactNode;
  variant?: "default" | "info" | "success" | "card";
  className?: string;
}

export function InlineTip({
  children,
  variant = "default",
  className,
}: InlineTipProps) {
  if (variant === "card") {
    return (
      <div
        className={cn(
          "rounded-md border border-border/30 bg-muted/20 p-3",
          "text-xs leading-relaxed",
          className
        )}
      >
        <p className="text-muted-foreground leading-relaxed">
          {children}
        </p>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "relative flex items-start gap-2.5 px-3 py-2",
        "bg-muted/40 dark:bg-muted/20",
        "border-l-2 border-foreground/10 dark:border-foreground/20",
        "text-xs leading-relaxed",
        className
      )}
    >
      <HugeiconsIcon
        icon={BulbIcon}
        size={12}
        className={cn(
          "shrink-0 mt-0.5",
          "text-foreground/40 dark:text-foreground/50",
          "transition-colors"
        )}
      />
      <p className="text-foreground/70 dark:text-foreground/60 leading-relaxed flex-1">
        {children}
      </p>
    </div>
  );
}
